import { ConnectionState } from "../states/connection";
import { ETimerActions, TimerActions } from "../actions/timer";
import { IConnection } from "src/app/models/connection";
import { ConnectionAction, EConnectionAction } from "../actions/connection";

export function ConnectionReducers(
  state: IConnection = ConnectionState,
  action: ConnectionAction,
): IConnection {
  switch (action.type) {
    case EConnectionAction.Online: {
      return {
        ...state,
        connected: action.payload.connected,
      };
    }
    default:
      return state;
  }
}
